import React from "react";

export const IconCaretRight = ({ className, isRedesign = false, ...props }) => {
  // Default dimensions for original design
  let width = props.width || 8;
  let height = props.height || 13;
  let viewBox = "0 0 8 13";

  // Update dimensions for redesign variant
  if (isRedesign) {
    width = props.width || 6;
    height = props.height || 11;
    viewBox = "0 0 6 11";
  }

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isRedesign ? (
        <path
          d="M1.00049 9.5L5.00049 5.5L1.00049 1.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path d="M1.05033 1.55025L6.00008 6.5L1.05033 11.4497" stroke="#4E588C" strokeWidth="2" />
      )}
    </svg>
  );
};
